import Routes from '../router/route-constants'

export default ([
  {
    id    : 'patients',
    label : 'Cases',
    icon  : 'list',
    route : Routes.ROOT_ROUTE_CASES,
    // notif : {
    //   type: 'alert',
    //   text: '3'
    // }
  },
  {
    id    : 'submissions',
    label : 'Submissions',
    icon  : 'action-share',
    route : Routes.ROUTE_SUBMISSION_CASES,
  },
  // Removed at v7
  /*{
    id    : 'reports',
    label : 'Reports',
    icon  : 'action-report',
    route : Routes.ROOT_ROUTE_REPORTS,
    mode  : 'compact'
  },*/
  // { id    : 'spacer'}
])
